module.exports = __webpack_public_path__ + "assets/e8b07dccaeb252cfb49e45ee0b476f6d.jpg";